import appConfig from '../../appConfig';

const voltran = require('/home/node/app/node_modules/voltranjs/src/index');

import React, { useEffect, useState, lazy, Suspense } from 'react';
import LoyaltyService from 'Service/LoyaltyService';
import ROUTE_PATHS from '../../routes/routeConstants';
import { mobileCheck } from 'Utils/helper';

const MobileBanner = lazy(() => import('../PdpLoyaltyTouchPoint/MobileBanner/MobileBanner'));
const WebBanner = lazy(() => import('../PdpLoyaltyTouchPoint/WebBanner/WebBanner'));

const LoyaltyTouchPoint = ({ initialState: { location } }) => {
  const [isMobile, setMobile] = useState(false);
  const [initialSource, setInitialSource] = useState(null);
  const [data, setData] = useState(null);
  const [source, setSource] = useState('');
  const [productSku, setProductSku] = useState(null);
  const [userId, setUserId] = useState(null);
  const [redirectUrl, setRedirectUrl] = useState(null);
  const [isOneClickAvailable, setIsOneClickAvailable] = useState(false);
  const [isHidden, setIsHidden] = useState(true);

  const fetchAdvantagesByProduct = async ({
    definitionId,
    finalPrice,
    sku,
    tenant = 1,
    userId: customerId,
    merchantId,
    shippingCompensationAmount
  }) => {
    try {
      const resp = await LoyaltyService.calculateAdvantagesByProduct({
        customerId,
        tenant: Number(tenant) || null,
        sku: sku || null,
        definitionId: definitionId || null,
        finalPrice: Number(finalPrice) || null,
        merchantId: merchantId || null,
        shippingCompensationAmount: shippingCompensationAmount || null
      });
      setRedirectUrl(resp?.data?.redirectUrl);
      setIsOneClickAvailable(resp?.data?.canOpenOneClickScreen);
      delete resp?.data?.redirectUrl;
      setData(resp.data);
      setProductSku(sku);
    } catch (error) {
      console.error({ error });
    }
  };

  const refetchAdvantages = ({
    sku,
    userId,
    definitionId,
    finalPrice,
    merchantId,
    shippingCompensationAmount,
    isMobile: isMobileView
  }) => {
    setMobile(isMobileView?.toString() === 'true');

    if (window?.navigator) {
      setMobile(mobileCheck(window?.navigator?.userAgent));
    }
    fetchAdvantagesByProduct({
      definitionId,
      finalPrice,
      sku,
      userId,
      merchantId,
      shippingCompensationAmount
    });
    setUserId(userId);
  };

  const checkOnInitCall = () => {
    const urlParams = new URLSearchParams(window?.location?.search);
    const premiumOneClick = urlParams.get('premiumOneClick');
    if (premiumOneClick) {
      setIsHidden(false);
      setInitialSource(premiumOneClick);
      return premiumOneClick;
    }
    return null;
  };
  const getQueryList = source => {
    switch (source) {
      case 'pdp':
        return `pdp&sku=${location?.query?.sku}&finalPrice=${location?.query?.finalPrice}&definitionId=${location?.query?.definitionId}&merchantId=${location?.query?.merchantId}`;
      case 'order_detail':
        return `pdp&sku=${location?.query?.sku}&finalPrice=${location?.query?.finalPrice}&definitionId=${location?.query?.definitionId}&merchantId=${location?.query?.merchantId}&shippingCompensationAmount=${location?.query?.shippingCompensationAmount}`;
      default:
        return location?.query?.source;
    }
  };

  useEffect(() => {
    setIsHidden(location?.query?.isHidden === 'true' || false);
    window.OneClickFullFillment = function(payload) {
      setInitialSource(null);
      setSource(payload?.source);
      setInitialSource(payload?.source);
      setIsOneClickAvailable(true);
      setIsHidden(false);
    };

    checkOnInitCall();
    window.Loyalty = {
      fetchAdvantagesByProduct: params =>
        refetchAdvantages({
          ...params
        })
    };
  }, []);

  useEffect(() => {
    const querySource = getQueryList(location?.query?.source);
    setSource(querySource || checkOnInitCall());
  }, [location]);

  useEffect(() => {
    if (!isHidden) {
      refetchAdvantages(location.query);
    }
  }, [isHidden]);

  if (!data || isHidden) {
    return null;
  }

  if (isMobile) {
    return (
      <Suspense fallback={<div />}>
        <MobileBanner
          userId={userId}
          sku={productSku}
          redirectUrl={
            isOneClickAvailable
              ? `${appConfig.paymentVoltranUrl}/OneClickPayment?source=${source}`
              : redirectUrl
          }
          initialSource={initialSource}
          isHidden={isHidden}
          isOneClickAvailable={isOneClickAvailable}
          isVoltranUrl
          {...data}
        />
      </Suspense>
    );
  }

  return (
    <Suspense fallback={<div />}>
      <WebBanner
        redirectUrl={
          isOneClickAvailable
            ? `${appConfig.paymentVoltranUrl}/OneClickPayment?source=${source}`
            : redirectUrl
        }
        isVoltranUrl
        isOneClickAvailable={isOneClickAvailable}
        userId={userId}
        sku={productSku}
        initialSource={initialSource}
        isHidden={isHidden}
        {...data}
      />
    </Suspense>
  );
};

const component = voltran.default.withBaseComponent(
  LoyaltyTouchPoint,
  ROUTE_PATHS.LOYALTY_TOUCHPOINT
);

component.services = [];

export default component;
